module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icon_lpo02-53738456a388d969dbb93f2c15df6493.svg";